export default "__VITE_ASSET__zCwxIt9c__"